import { EntityStringIdRouteCodec, LatinWordPrefixCodec, makeRouteCodec, SlugCodec } from 'app/constants/Routes/codecs';
import DynamicRoute from 'app/constants/Routes/DynamicRoute';
import StaticRoute from 'app/constants/Routes/StaticRoute';
import { LatinPrefix } from 'app/constants/WordPrefix';
import { EntityStringId } from 'app/types/entity';

const WORDS_PREFIX = '/words';
const UKNOW_PREFIX = '/uknow';

/**
 * This interface contains a mapping to routes that meet a common interface.
 */
export interface IWordsRoutes {
  AnswerEditor: StaticRoute;
  QuestionList: StaticRoute;
  QuestionUpload: StaticRoute;
  WordList: DynamicRoute<{ prefix: LatinPrefix }>;
  Word: DynamicRoute<{ id: EntityStringId; slug: string }>;
}

const makeWordsRoutes = (prefix: string): IWordsRoutes => ({
  AnswerEditor: new StaticRoute({
    route: `${prefix}/answer-editor`,
    syncable: true,
  }),
  QuestionList: new StaticRoute({
    route: `${prefix}/questions/en`,
    syncable: true,
  }),
  QuestionUpload: new StaticRoute({
    route: `${prefix}/upload`,
    syncable: false,
  }),
  WordList: new DynamicRoute<{ prefix: LatinPrefix }>({
    route: `${prefix}/list/en/:prefix`,
    syncable: true,
    codec: makeRouteCodec({
      prefix: LatinWordPrefixCodec,
    }),
  }),
  Word: new DynamicRoute<{
    id: EntityStringId;
    slug: string;
  }>({
    route: `${prefix}/word/:slug/:id`,
    syncable: true,
    codec: makeRouteCodec({
      id: EntityStringIdRouteCodec,
      slug: SlugCodec,
    }),
  }),
});

// uKnow is primarily a special kind of route used for branding on eikaiwa that might
// not make sense in the Engoo context. To prevent route resolution ambiguities and eleviate
// problems with call syncability, two sets of routes are defined and used. When using these,
// context is important and referencing the routes from here is likely to be wrong.
export const UKnowRoutes: IWordsRoutes = makeWordsRoutes(UKNOW_PREFIX);
export const WordsRoutes: IWordsRoutes = makeWordsRoutes(WORDS_PREFIX);
